<template>
  <div id="main">
    <div class="container-fluid wrap">
      <div class="row intro">
        <div class="col-12 text-center register">
          <h1 class="title">
            Faça parte
          </h1>
          <h3 class="subtitle">
            Ficha de Cadastro
          </h3>
          <p class="desc strong mb-0 text-uppercase">
            Venha fazer parte da nossa equipe!
          </p>
        </div>
      </div>

      <!-- <div v-if="isLoaded === true" class="row select-job">
        <div class="col-12 select">
          <label for="job">Cargo: </label>
          <select @change="setJob()" class="custom-select" name="job" id="job" v-model="job">
            <option value="" selected disabled hidden>Selecione</option>
            <option
              v-for="category in Object.keys(options['category'])"
              :key="category"
              :value="category"
            >{{ options['category'][category] }}</option>
          </select>
        </div>
      </div> -->

      <div class="row dynamic justify-content-center reset-row">
        <dynamic-form
          :joboptions="options"
          :inputs="inputs"
          :bankInfo="bankInfo"
          :selects="selects"
          :images="images"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import options from '../assets/options/options'
import DynamicForm from '../components/DynamicForm'

export default {
  name: 'app',

  props: {
    csrf: {
      type: String,
      required: true
    }
  },

  components: {
    'dynamic-form': DynamicForm
  },

  data () {
    return {
      isLoaded: false,
      // job: '',
      // formatedJob: [],
      options: {},
      inputs: [
        {
          margin: 'mlr--5',
          row: [
            {
              id: 0,
              name: 'job',
              placeholder: 'Cargo',
              type: 'select',
              multiple: false,
              grid: 'col-md-12 plr-5',
              validate: 'required'
            }
          ]
        },
        {
          margin: 'mlr--5',
          row: [
            {
              id: 1,
              name: 'name',
              placeholder: 'Nome Completo',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required|alpha_spaces'
            },
            {
              id: 2,
              name: 'email',
              placeholder: 'E-mail',
              type: 'email',
              grid: 'col-md-6 plr-5',
              validate: 'required|email'
            }
          ]
        },
        {
          margin: 'mlr--5',
          row: [
            {
              id: 3,
              name: 'gender',
              placeholder: 'Gênero',
              type: 'select',
              multiple: false,
              grid: 'col-md-3 plr-5',
              validate: 'required',
              options: options.gender
            },
            {
              id: 4,
              name: 'birthdate',
              placeholder: 'Data de Nascimento',
              type: 'text',
              grid: 'col-md-3 plr-5',
              validate: 'required|date_format:dd/MM/yyyy'
            },
            {
              id: 5,
              name: 'mobile',
              placeholder: 'Celular',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required'
            }
          ]
        },
        {
          margin: 'mlr--5',
          row: [
            {
              id: 6,
              name: 'langs',
              placeholder: 'Idiomas Fluentes',
              type: 'select',
              multiple: true,
              grid: 'col-md-6 plr-5',
              validate: 'required',
              options: options.translate_langs.en
            },
            {
              id: 7,
              name: 'father',
              placeholder: 'Nome do Pai',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required|alpha_spaces'
            }
          ]
        },
        {
          margin: 'mlr--5',
          row: [
            {
              id: 8,
              name: 'address',
              placeholder: 'Endereço',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required'
            },
            {
              id: 9,
              name: 'mother',
              placeholder: 'Nome da Mãe',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required|alpha_spaces'
            }
          ]
        },
        {
          margin: 'mlr--5',
          row: [
            {
              id: 10,
              name: 'id_num',
              placeholder: 'RG',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required'
            },
            {
              id: 11,
              name: 'id_fiscal_num',
              placeholder: 'CPF',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required'
            }
          ]
        },
        {
          margin: 'mlr--5',
          row: [
            {
              id: 12,
              name: 'emergency_contact',
              placeholder: 'Nome do Contato de Emergência',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required|alpha_spaces'
            },
            {
              id: 13,
              name: 'emergency_contact_phone',
              placeholder: 'Telefone do Contato de Emergência',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required'
            }
          ]
        }
      ],
      bankInfo: [
        {
          margin: 'mlr--5',
          row: [
            {
              id: 14,
              name: 'bank',
              placeholder: 'Banco',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required'
            },
            {
              id: 15,
              name: 'bank_agency',
              placeholder: 'Agência',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required'
            }
          ]
        },
        {
          margin: 'mlr--5',
          row: [
            {
              id: 16,
              name: 'bank_account_type',
              placeholder: 'Tipo de Conta',
              type: 'select',
              multiple: false,
              grid: 'col-md-6 plr-5',
              validate: 'required',
              options: options.type_account
            },
            {
              id: 17,
              name: 'bank_account',
              placeholder: 'Conta',
              type: 'text',
              grid: 'col-md-6 plr-5',
              validate: 'required'
            }
          ]
        }
      ],
      selects: [
        {
          margin: 'mlr--5',
          row: [
            {
              id: 18,
              name: 'height',
              placeholder: 'Altura',
              type: 'select',
              multiple: false,
              grid: 'col-md-4 plr-5',
              validate: 'required',
              options: options.height
            },
            {
              id: 19,
              name: 'jeans_1',
              placeholder: 'Manequim',
              type: 'select',
              multiple: false,
              grid: 'col-md-4 plr-5',
              validate: 'required',
              options: options.jeans
            },
            // {
            //   id: 20,
            //   name: 'jeans_2',
            //   placeholder: '',
            //   type: 'select',
            //   multiple: false,
            //   grid: 'col-md-2 ml--3',
            //   validate: 'required',
            //   options: options.jeans
            // },
            // {
            //   id: 21,
            //   name: 'jeans_unit',
            //   placeholder: '',
            //   type: 'select',
            //   multiple: false,
            //   grid: 'col-md-2 ml-2-custom',
            //   validate: 'required',
            //   options: options.measurements_type
            // },
            {
              id: 22,
              name: 'shoes',
              placeholder: 'Sapato',
              type: 'select',
              multiple: false,
              grid: 'col-md-4 plr-5',
              validate: 'required',
              options: options.shoes
            }
            // {
            //   id: 23,
            //   name: 'shoes_unit',
            //   placeholder: '',
            //   type: 'select',
            //   multiple: false,
            //   grid: 'col-md-2 ml--3',
            //   validate: 'required',
            //   options: options.measurements_type
            // }
          ]
        }
      ],
      images: [
        {
          id: 1,
          name: 'Front_1',
          placeholder: 'ROSTO'
        },
        {
          id: 2,
          name: 'Front_2',
          placeholder: 'ROSTO'
        },
        {
          id: 3,
          name: 'FullBody_1',
          placeholder: 'CORPO INTEIRO'
        },
        {
          id: 4,
          name: 'FullBody_2',
          placeholder: 'CORPO INTEIRO'
        },
        {
          id: 5,
          name: 'FullBody_3',
          placeholder: 'CORPO INTEIRO'
        }
      ]
    }
  },

  created () {
    let auth

    if (this.csrf) {
      auth = 'Bearer ' + this.csrf
    } else {
      console.error('CSRF token not found')
    }
    axios.get('https://integration.managerfashion.net/api/talent/categories', {
      headers: {
        Authorization: auth
      }
    })
      .then(response => {
        const categories = {}
        response.data.forEach(item => {
          categories[item.id] = item.name
        })

        this.$set(this.options, ['category'], categories)

        setTimeout(() => {
          this.isLoaded = true
        }, 100)
      })
  },

  mounted () {
    this.$set(this.inputs[0].row[0], 'options', this.options)
  },

  methods: {
    // setJob () {
    //   this.formatedJob.push(
    //     JSON.stringify([{
    //       value: this.job,
    //       emailData: this.options['category'][this.job],
    //       label: 'Cargo'
    //     }])
    //   )
    // }
  }
}
</script>

<style lang="scss">
@import '../assets/css/slimselect.scss';
@import '../assets/css/global.scss';

#main{
  margin: 60px 0;

  .wrap{
    .intro{
      margin: 0 0 0 0;
    }

    .select-job{
      margin: 13px 0 60px 0;

      .select{
        display: flex;
        justify-content: center;

        label{
          display: flex;
          align-items: center;
          margin-bottom: 0;
          margin-right: 10px;

          color: white;
          font-size: 14px;
          font-weight: 500;
        }

        .custom-select{
          max-width: 200px;
          border-radius: 0;
          border-color: #884E79;

          color: #884E79;
          font-size: 14px;
          font-weight: 300;

          option{
            color: #884E79;
            font-size: 14px;
            font-weight: 300;
          }

          &:focus,
          &:hover,
          &:active{
            outline: none;
            box-shadow: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/App.vue